import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Advantages } from './components/Advantages';
import { Fleet } from './components/Fleet';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
const SEO = {
  title: 'Rental Mobil Garut | Sewa Mobil Garut Terpercaya - PT Wardah Pratama Transport',
  description: 'Rental Mobil Garut & Sewa Mobil Garut terpercaya. Layanan City Tour Garut, Jemput Bandara Garut, Wisata Religi Garut, Rental Mobil Harian & Bulanan Garut. Armada premium, driver profesional, siap 24 jam.',
  keywords: 'Rental Mobil Garut, Sewa Mobil Garut, City Tour Garut, Jemput Bandara Garut, Wisata Religi Garut, Rental Mobil Harian Garut, Rental Mobil Bulanan Garut'
};
function useSEO() {
  useEffect(() => {
    document.title = SEO.title;
    document.documentElement.lang = 'id';
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('name', 'description', SEO.description);
    setMeta('name', 'keywords', SEO.keywords);
    setMeta('property', 'og:title', SEO.title);
    setMeta('property', 'og:description', SEO.description);
    setMeta('property', 'og:type', 'website');
  }, []);
}
export function App() {
  useSEO();
  return <div className="min-h-screen w-full bg-ink text-white" data-id="element-0" data-mp="nxn71wrpjbph">
      <Navbar data-id="element-1" data-mp="stkns46vuk2s" />
      <main data-id="element-2" data-mp="st2gmciomlg3">
        <Hero data-id="element-3" data-mp="sssskuh76od1" />
        <Services data-id="element-4" data-mp="swgmhuqk1csa" />
        <Advantages data-id="element-5" data-mp="36877lhgoowl" />
        <Fleet data-id="element-6" data-mp="35ovimiemwr0" />
        <About data-id="element-7" data-mp="356r32ll9c80" />
        <Testimonials data-id="element-8" data-mp="34nbvtnbp1xo" />
        <CallToAction data-id="element-9" data-mp="38b2ol1dva8p" />
        <Contact data-id="element-10" data-mp="3uday0bte0t6a" />
      </main>
      <Footer data-id="element-11" data-mp="3ubztuaw15jen" />
      <WhatsAppButton data-id="element-12" data-mp="3ucjcjtti8btq" />
    </div>;
}